import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  AssignGMToTenantRequest,
  AssignGMToTenantResponse,
  GetTenantAssignmentsResponse,
  DeactivateAssignmentResponse,
  GetMyAssignmentsResponse,
  GetAvailableTenantsResponse,
  SwitchToTenantRequest,
  SwitchToTenantResponse,
  ApiResponse,
  GetMyAssignedTenantsResponse,
  GetAvailableGMsResponse,
  GetMyManagedAssignmentsResponse,
  GetAssignmentSummaryResponse,
  GetMyMarketAreasResponse,
  GetTenantGMsResponse,
  GetGMAssignmentsResponse
} from '../../../../interfaces/src/lib/gm-assignment.interface';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GmAssignmentService {
  private readonly baseUrl = `${environment.apiUrl}/api/gm-tenant-assignments`;

  constructor(private http: HttpClient) {}

  // Admin/AM/Developer endpoints
  assignGMToTenant(data: AssignGMToTenantRequest): Observable<AssignGMToTenantResponse> {
    return this.http.post<AssignGMToTenantResponse>(`${this.baseUrl}/assign`, data);
  }

  getTenantAssignments(tenantId: string): Observable<GetTenantAssignmentsResponse> {
    return this.http.get<GetTenantAssignmentsResponse>(`${this.baseUrl}/tenant/${tenantId}`);
  }

  deactivateAssignment(assignmentId: string): Observable<DeactivateAssignmentResponse> {
    return this.http.patch<DeactivateAssignmentResponse>(`${this.baseUrl}/deactivate/${assignmentId}`, {});
  }

  // GM endpoints
  getMyAssignments(): Observable<GetMyAssignmentsResponse> {
    return this.http.get<GetMyAssignmentsResponse>(`${this.baseUrl}/my-assignments`);
  }

  getAvailableTenants(): Observable<GetAvailableTenantsResponse> {
    return this.http.get<GetAvailableTenantsResponse>(`${this.baseUrl}/available-tenants`);
  }

  switchToTenant(data: SwitchToTenantRequest): Observable<SwitchToTenantResponse> {
    return this.http.post<SwitchToTenantResponse>(`${this.baseUrl}/switch-tenant`, data);
  }

  getAssignmentHistory(): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(`${this.baseUrl}/assignment-history`);
  }

  getCurrentTenant(): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(`${this.baseUrl}/current-tenant`);
  }

  validateTenantAccess(tenantId: string): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(`${this.baseUrl}/validate-access/${tenantId}`);
  }

  // Area Manager endpoints
  getMyAssignedTenants(): Observable<GetMyAssignedTenantsResponse> {
    return this.http.get<GetMyAssignedTenantsResponse>(`${this.baseUrl}/am/my-assigned-tenants`);
  }

  getAvailableGMs(): Observable<GetAvailableGMsResponse> {
    return this.http.get<GetAvailableGMsResponse>(`${this.baseUrl}/am/available-gms`);
  }

  getMyManagedAssignments(): Observable<GetMyManagedAssignmentsResponse> {
    return this.http.get<GetMyManagedAssignmentsResponse>(`${this.baseUrl}/am/managed-assignments`);
  }

  getAssignmentSummary(): Observable<GetAssignmentSummaryResponse> {
    return this.http.get<GetAssignmentSummaryResponse>(`${this.baseUrl}/am/assignment-summary`);
  }

  getMyMarketAreas(): Observable<GetMyMarketAreasResponse> {
    return this.http.get<GetMyMarketAreasResponse>(`${this.baseUrl}/am/market-areas`);
  }

  getTenantGMs(tenantId: string): Observable<GetTenantGMsResponse> {
    return this.http.get<GetTenantGMsResponse>(`${this.baseUrl}/am/tenant/${tenantId}/gms`);
  }

  getGMAssignments(gmUserId: string): Observable<GetGMAssignmentsResponse> {
    return this.http.get<GetGMAssignmentsResponse>(`${this.baseUrl}/am/gm/${gmUserId}/assignments`);
  }
} 